import React, { useEffect, useState, memo } from 'react'
import { connect } from 'react-redux'
import {
    Layout,
    Button,
    Popover,
    Menu,
    Dropdown,
    Icon,
    Checkbox,
    DatePicker,
    Mention,
    Input,
} from 'antd'
import SearchInput from '../../../componentIsoMophic/ScrumBoard/SearchInput/SearchInput'
import { Scrollbars } from 'react-custom-scrollbars'
import modalActions from '../../../redux/modal/actions'
import scrumBoardActions from '../../../redux/scrumBoard/actions'
import { Title, Filters, Header, HeaderSecondary } from './AppLayout.style'
import Modal from '../../../components/feedback/modal'
import moment from 'moment'
import { Pagination } from 'antd'

import ContentCreateTask from '../Board/ContentCreateTask/index'

const { toString, toContentState } = Mention

const { Content } = Layout
const { MonthPicker, RangePicker, WeekPicker } = DatePicker
const AppLayout = ({
    children,
    setSearchText,
    history,
    match,
    getListBoard,
    getListTaskStar,
    pageIndex,
    updatePageIndexBoard,
    searchTaskInfo,
    getListTaskByHashTag,
    visibleModalCreateTask,
    visibleModalCreateTaskAction,
    getListTaskAboutTime,
    getListTask,
    getListTaskMergeOption,
    listHashTagAll,
    getListHashTagAll,
    totalSize,
}) => {
    useEffect(() => {
        getListHashTagAll()
    }, [getListHashTagAll])

    const [isAll, setisAll] = useState(0)

    const [typeSearch, settypeSearch] = useState('name')
    const [visible, setvisible] = useState(false)
    const [currentStatus, setCurrentStatus] = useState(-1)
    const [timestart, settimestart] = useState(0)
    const [timeend, settimeend] = useState(0)
    const [text, settext] = useState('')

    const _handleOK = () => {
        visibleModalCreateTaskAction(false)
    }
    const _handleCancel = () => {
        visibleModalCreateTaskAction(false)
    }
    const onchange = pageNumber => {
        if (isAll === 0) {
            const body = {
                filter_option: { all: true },
                filter_text:
                    text !== ''
                        ? typeSearch === 'name'
                            ? { text: text }
                            : { hashtag: text }
                        : {},
                status: currentStatus === -1 ? 6 : currentStatus,
            }
            getListTaskMergeOption(pageNumber, 10, body)
            updatePageIndexBoard(pageNumber)
        }
        if (isAll === 1) {
            const body = {
                filter_option: { care: true },
                filter_text:
                    text !== ''
                        ? typeSearch === 'name'
                            ? { text: text }
                            : { hashtag: text }
                        : {},
                status: currentStatus === -1 ? 6 : currentStatus,
            }
            getListTaskMergeOption(pageNumber, 10, body)
            updatePageIndexBoard(pageNumber)
        }
        if (isAll === 2) {
            const body = {
                filter_option: {
                    about_time: {
                        begin: timestart,
                        end: timeend,
                    },
                },
                filter_text:
                    text !== ''
                        ? typeSearch === 'name'
                            ? { text: text }
                            : { hashtag: text }
                        : {},
                status: currentStatus === -1 ? 6 : currentStatus,
            }
            getListTaskMergeOption(pageNumber, 10, body)
            updatePageIndexBoard(pageNumber)
        }
    }
    const onchangeTime = e => {
        if (e[0] && e[1]) {
            console.log('data time', e[0]._d + '   ' + e[1]._d)
            settimestart((e[0]._d.valueOf() / 1000) >> 0)
            settimeend((e[1]._d.valueOf() / 1000) >> 0)
            const body = {
                filter_option: {
                    about_time: {
                        begin: (e[0]._d.valueOf() / 1000) >> 0,
                        end: (e[1]._d.valueOf() / 1000) >> 0,
                    },
                },
                filter_text:
                    text !== ''
                        ? typeSearch === 'name'
                            ? { text: text }
                            : { hashtag: text }
                        : {},
                status: currentStatus === -1 ? 6 : currentStatus,
            }
            getListTaskMergeOption(1, 10, body)
            updatePageIndexBoard(1)
        }
    }
    const onChangeFilter = data => {
        if (data === 1) {
            console.log('show star')
            // getListTaskStar(1)
            // updatePageIndexBoard(1)
            const body = {
                filter_option: { care: true },
                filter_text:
                    text !== ''
                        ? typeSearch === 'name'
                            ? { text: text }
                            : { hashtag: text }
                        : {},
                status: currentStatus === -1 ? 6 : currentStatus,
            }
            getListTaskMergeOption(1, 10, body)
            updatePageIndexBoard(1)
        }
        if (data === 0) {
            const body = {
                filter_option: { all: true },
                filter_text:
                    text !== ''
                        ? typeSearch === 'name'
                            ? { text: text }
                            : { hashtag: text }
                        : {},
                status: currentStatus === -1 ? 6 : currentStatus,
            }
            getListTaskMergeOption(1, 10, body)
            updatePageIndexBoard(1)
        }
    }
    const onSelect = suggestion => {
        settext(suggestion)
        console.log('suggestion', suggestion)
        if (isAll === 0) {
            if (suggestion === '') {
                updatePageIndexBoard(1)
                getListBoard(1, 6)
            } else {
                const body = {
                    filter_option: { all: true },
                    filter_text: { hashtag: suggestion },
                    status: currentStatus === -1 ? 6 : currentStatus,
                }
                getListTaskMergeOption(1, 10, body)
                updatePageIndexBoard(1)
            }
        }
        // search star + text + status
        if (isAll === 1) {
            if (suggestion === '') {
                const body = {
                    filter_option: { care: true },
                    filter_text: {},
                    status: currentStatus === -1 ? 6 : currentStatus,
                }
                getListTaskMergeOption(1, 10, body)
                updatePageIndexBoard(1)
            } else {
                const body = {
                    filter_option: { care: true },
                    filter_text: { hashtag: suggestion },
                    status: currentStatus === -1 ? 6 : currentStatus,
                }
                getListTaskMergeOption(1, 10, body)
                updatePageIndexBoard(1)
            }
        }
        if (isAll === 2) {
            if (suggestion === '') {
                const body = {
                    filter_option: {
                        about_time: {
                            begin: timestart,
                            end: timeend,
                        },
                    },
                    filter_text: {},
                    status: currentStatus === -1 ? 6 : currentStatus,
                }
                getListTaskMergeOption(1, 10, body)
                updatePageIndexBoard(1)
            } else {
                const body = {
                    filter_option: {
                        about_time: {
                            begin: timestart,
                            end: timeend,
                        },
                    },
                    filter_text: { hashtag: suggestion },
                    status: currentStatus === -1 ? 6 : currentStatus,
                }
                getListTaskMergeOption(1, 10, body)
                updatePageIndexBoard(1)
            }
        }
    }
    const onChangeTextSearch = value => {
        settext(value)
        console.log('typeSearch', typeSearch)
        if (typeSearch === 'name') {
            if (isAll === 0) {
                if (value === '') {
                    updatePageIndexBoard(1)
                    getListBoard(1, 6)
                } else {
                    const body = {
                        filter_option: { all: true },
                        filter_text: { text: value },
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                }
            }
            // search star + text + status
            if (isAll === 1) {
                if (value === '') {
                    const body = {
                        filter_option: { care: true },
                        filter_text: {},
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                } else {
                    const body = {
                        filter_option: { care: true },
                        filter_text: { text: value },
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                }
            }
            if (isAll === 2) {
                if (value === '') {
                    const body = {
                        filter_option: {
                            about_time: {
                                begin: timestart,
                                end: timeend,
                            },
                        },
                        filter_text: {},
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                } else {
                    const body = {
                        filter_option: {
                            about_time: {
                                begin: timestart,
                                end: timeend,
                            },
                        },
                        filter_text: { text: value },
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                }
            }
        }
        if (typeSearch === 'tag') {
            console.log('value search text', value)

            if (isAll === 0) {
                if (value === '') {
                    updatePageIndexBoard(1)
                    getListBoard(1, 6)
                } else {
                    const body = {
                        filter_option: { all: true },
                        filter_text: { hashtag: value },
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                }
            }
            // search star + text + status
            if (isAll === 1) {
                if (value === '') {
                    const body = {
                        filter_option: { care: true },
                        filter_text: {},
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                } else {
                    const body = {
                        filter_option: { care: true },
                        filter_text: { hashtag: value },
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                }
            }
            if (isAll === 2) {
                if (value === '') {
                    const body = {
                        filter_option: {
                            about_time: {
                                begin: timestart,
                                end: timeend,
                            },
                        },
                        filter_text: {},
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                } else {
                    const body = {
                        filter_option: {
                            about_time: {
                                begin: timestart,
                                end: timeend,
                            },
                        },
                        filter_text: { hashtag: value },
                        status: currentStatus === -1 ? 6 : currentStatus,
                    }
                    getListTaskMergeOption(1, 10, body)
                    updatePageIndexBoard(1)
                }
            }
        }
    }
    const menu = (
        <Menu>
            <Menu.Item
                key="1"
                onClick={() => {
                    if (isAll === 0) {
                        const body = {
                            filter_option: { all: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 0,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(0)
                    }
                    if (isAll === 1) {
                        const body = {
                            filter_option: { care: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 0,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(0)
                    }
                    if (isAll === 2) {
                        const body = {
                            filter_option: {
                                about_time: {
                                    begin: timestart,
                                    end: timeend,
                                },
                            },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 0,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(0)
                    }
                }}
            >
                Nhiệm vụ mới khởi tạo
            </Menu.Item>
            <Menu.Item
                key="2"
                onClick={() => {
                    if (isAll === 0) {
                        const body = {
                            filter_option: { all: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 1,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(1)
                    }
                    if (isAll === 1) {
                        const body = {
                            filter_option: { care: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 1,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(1)
                    }
                    if (isAll === 2) {
                        const body = {
                            filter_option: {
                                about_time: {
                                    begin: timestart,
                                    end: timeend,
                                },
                            },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 1,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(1)
                    }
                }}
            >
                Nhiệm vụ mới triển khai
            </Menu.Item>

            <Menu.Item
                key="4"
                onClick={() => {
                    if (isAll === 0) {
                        const body = {
                            filter_option: { all: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 3,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(3)
                    }
                    if (isAll === 1) {
                        const body = {
                            filter_option: { care: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 3,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(3)
                    }
                    if (isAll === 2) {
                        const body = {
                            filter_option: {
                                about_time: {
                                    begin: timestart,
                                    end: timeend,
                                },
                            },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 3,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(3)
                    }
                }}
            >
                Nhiệm vụ đang làm
            </Menu.Item>
            <Menu.Item
                key="5"
                onClick={() => {
                    if (isAll === 0) {
                        const body = {
                            filter_option: { all: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 4,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(4)
                    }
                    if (isAll === 1) {
                        const body = {
                            filter_option: { care: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 4,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(4)
                    }
                    if (isAll === 2) {
                        const body = {
                            filter_option: {
                                about_time: {
                                    begin: timestart,
                                    end: timeend,
                                },
                            },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 4,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(4)
                    }
                }}
            >
                Nhiệm vụ đã hoàn thành
            </Menu.Item>
            <Menu.Item
                key="6"
                onClick={() => {
                    if (isAll === 0) {
                        const body = {
                            filter_option: { all: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 5,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(5)
                    }
                    if (isAll === 1) {
                        const body = {
                            filter_option: { care: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 5,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(5)
                    }
                    if (isAll === 2) {
                        const body = {
                            filter_option: {
                                about_time: {
                                    begin: timestart,
                                    end: timeend,
                                },
                            },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 5,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(5)
                    }
                }}
            >
                Nhiệm vụ đã xoá
            </Menu.Item>
            <Menu.Item
                key="7"
                onClick={() => {
                    if (isAll === 0) {
                        const body = {
                            filter_option: { all: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 6,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(-1)
                    }
                    if (isAll === 1) {
                        const body = {
                            filter_option: { care: true },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 6,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(-1)
                    }
                    if (isAll === 2) {
                        const body = {
                            filter_option: {
                                about_time: {
                                    begin: timestart,
                                    end: timeend,
                                },
                            },
                            filter_text:
                                text !== ''
                                    ? typeSearch === 'name'
                                        ? { text: text }
                                        : { hashtag: text }
                                    : {},
                            status: 6,
                        }
                        getListTaskMergeOption(1, 10, body)
                        updatePageIndexBoard(1)
                        setCurrentStatus(-1)
                    }
                }}
            >
                Tất cả
            </Menu.Item>
        </Menu>
    )
    const handleVisibleChange = visible => {
        setvisible(visible)
    }

    return (
        <Layout
            style={
                {
                    // backgroundColor: '#fff',
                    // minHeight: '100vh',
                }
            }
        >
            <Header>
                <Title>Danh sách nhiệm vụ</Title>

                <Button
                    type="primary"
                    onClick={() => visibleModalCreateTaskAction(true)}
                >
                    Tạo nhiệm vụ
                </Button>
            </Header>
            <Scrollbars
                style={{
                    width: '100%',
                    height: 'calc(100vh - 140px)',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundImage: `url(${require('../../../resource/image/blur-bg.jpg')}`,
                }}
            >
                <HeaderSecondary>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        {typeSearch === 'name' && (
                            <div
                                style={{
                                    width: 400,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Icon
                                    type="search"
                                    style={{ paddingRight: 10, color: 'white' }}
                                />
                                <Input
                                    style={{
                                        height: 35,
                                        backgroundColor: '#5b746f',
                                        color: 'white',
                                    }}
                                    placeholder="Nhập tên nhiệm vụ để tìm kiếm"
                                    value={text}
                                    onChange={e =>
                                        onChangeTextSearch(e.target.value)
                                    }
                                />
                            </div>
                        )}
                        {typeSearch === 'tag' && (
                            <div
                                style={{
                                    width: 400,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Icon
                                    type="search"
                                    style={{ paddingRight: 10 }}
                                />
                                <Mention
                                    onChange={editorState =>
                                        onChangeTextSearch(
                                            toString(editorState)
                                        )
                                    }
                                    placeholder="Nhập @ + hashtag để hiển thị gợi ý"
                                    defaultSuggestions={listHashTagAll}
                                    onSelect={onSelect}
                                />
                            </div>
                        )}

                        <Filters>
                            <Popover
                                placement="bottom"
                                overlayClassName=""
                                content={
                                    <div>
                                        <Checkbox
                                            onChange={() =>
                                                settypeSearch('name')
                                            }
                                            checked={
                                                typeSearch === 'name'
                                                    ? true
                                                    : false
                                            }
                                        >
                                            Lọc theo tên
                                        </Checkbox>
                                        <Checkbox
                                            onChange={() =>
                                                settypeSearch('tag')
                                            }
                                            checked={
                                                typeSearch === 'tag'
                                                    ? true
                                                    : false
                                            }
                                        >
                                            Lọc theo hashtag
                                        </Checkbox>
                                    </div>
                                }
                                trigger="click"
                            >
                                <div
                                    style={{
                                        paddingLeft: 10,
                                        paddingTop: 5,
                                        color: '#eaebed',
                                    }}
                                >
                                    {typeSearch === 'name' && 'Lọc theo tên'}
                                    {typeSearch === 'tag' && 'Lọc theo hashtag'}
                                    <Icon type="caret-down" />
                                </div>
                            </Popover>
                        </Filters>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        {isAll === 2 && (
                            <RangePicker
                                style={{ padding: 10 }}
                                format="DD/MM/YYYY"
                                placeholder={[
                                    'Thời gian đầu',
                                    'Thời gian cuối',
                                ]}
                                ranges={{
                                    Today: [moment(), moment()],
                                    'This Month': [
                                        moment().startOf('month'),
                                        moment().endOf('month'),
                                    ],
                                }}
                                onChange={e => onchangeTime(e)}
                                // ranges={{
                                //     Today: [moment(), moment()],
                                //     'This Month': [
                                //         moment().startOf('month'),
                                //         moment().endOf('month'),
                                //     ],
                                // }}
                            />
                        )}
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Dropdown
                                overlay={menu}
                                onVisibleChange={handleVisibleChange}
                                visible={visible}
                            >
                                <span
                                    style={{
                                        paddingRight: 20,
                                        fontSize: 15,
                                        color: '#eaebed',
                                    }}
                                >
                                    {currentStatus === -1 && 'Tất cả'}{' '}
                                    {currentStatus === 0 &&
                                        'Nhiệm vụ mới khởi tạo'}{' '}
                                    {currentStatus === 1 &&
                                        'Nhiệm vụ mới triển khai'}{' '}
                                    {currentStatus === 3 && 'Nhiệm vụ đang làm'}{' '}
                                    {currentStatus === 4 &&
                                        'Nhiệm vụ đã hoàn thành'}{' '}
                                    {currentStatus === 5 && 'Nhiệm vụ đã xoá'}{' '}
                                    <Icon type="caret-down" />
                                </span>
                            </Dropdown>
                            <Popover
                                placement="bottom"
                                content={
                                    <div>
                                        <Checkbox
                                            onChange={value => {
                                                if (value.target.checked) {
                                                    setisAll(0)
                                                    onChangeFilter(0)
                                                }
                                            }}
                                            checked={isAll === 0}
                                        >
                                            Tất cả
                                        </Checkbox>
                                        <Checkbox
                                            onChange={value => {
                                                if (value.target.checked) {
                                                    setisAll(1)
                                                    onChangeFilter(1)
                                                }
                                            }}
                                            checked={isAll === 1}
                                        >
                                            Quan tâm
                                        </Checkbox>
                                        <Checkbox
                                            onChange={value => {
                                                if (value.target.checked) {
                                                    setisAll(2)
                                                    onChangeFilter(2)
                                                }
                                            }}
                                            checked={isAll === 2}
                                        >
                                            Thời gian
                                        </Checkbox>
                                    </div>
                                }
                            >
                                <span
                                    style={{ fontSize: 15, color: '#eaebed' }}
                                >
                                    {isAll === 0 && 'Tất cả'}{' '}
                                    {isAll === 1 && 'Quan tâm'}{' '}
                                    {isAll === 2 && 'Thời gian'}{' '}
                                    <Icon type="caret-down" />
                                </span>
                            </Popover>
                        </div>
                    </div>
                </HeaderSecondary>

                <Content
                    style={{
                        padding: '0 24px',
                    }}
                >
                    {children}
                </Content>
                <div
                    style={{
                        marginBottom: 30,
                        width: '100%',
                        textAlign: 'center',
                    }}
                >
                    <Pagination
                        onChange={pageNumber => onchange(pageNumber)}
                        current={pageIndex}
                        total={totalSize}
                        pageSize={10}
                    />
                </div>
            </Scrollbars>

            <Modal
                maskClosable={false}
                destroyOnClose={true}
                visible={visibleModalCreateTask}
                onOk={() => _handleOK()}
                onCancel={() => _handleCancel()}
                width={window.innerWidth / 2}
                centered={false}
                footer={[]}
            >
                <ContentCreateTask history={history} />
            </Modal>
        </Layout>
    )
}

export default connect(
    state => ({
        pageIndex: state.scrumBoard.pageIndex,
        visibleModalCreateTask: state.scrumBoard.visibleModalCreateTask,
        listHashTagAll: state.scrumBoard.listHashTagAll,
        totalSize: state.scrumBoard.totalSize,
    }),
    { ...modalActions, ...scrumBoardActions }
)(AppLayout)
